import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { IPageState } from '../../contexts/PageContext';
import { CHARGE_TYPES, CURRENCIES, DOCUMENT_TYPES, MINTED_SALES, NUMBER_REGEX, PATHS, TRANSACTION_STATUS, TRANSACTION_TYPES, WEIGHT_UNITS } from '../../utils/constant';
import { LINE_ITEM_COLUMNS, ORDER_DETAILS_FORM, getAmount, getMetalType, getTotalValue } from '../$PhysicalOrder';
import { formatDate, genId, getFormattedCurrency, getTwoPointNumber, objToArray } from '../../utils/helpers';
import Billing from './Billing';
import Summary from './Summary';
import { EcomTransactionContext } from '../../contexts/ecomOrderContext';
import { AuthContext } from '../../contexts/AuthContext';
import { TTransactionBasic } from '../../Models/Transactions';
import useService from '../../hooks/useService';
import { completeEcomRedeemAtPvcOrder, createAndCompleteMintedPhysicalOrder, createProductScanException, fetchTransactionDocumentsList, getEcomRedeemAtPvcOrderDetails, getecomRedeemAtPvcProducts, getLotDetails, getPhysicalOrder, getProducts, getTransaction as getTransactionService, updateMintedPhysicalOrder } from '../../services/Transactions';
import { CustomerContext } from '../../contexts/CustomerContext';
import { Button, IconButton, TextField } from '@mui/material';
import { NotificationContext } from '../../contexts/NotificationContext';
import { TMintedSelectedProduct, TProductsColumns } from '../../Models/PhysicalOrder';
import { TColumn } from '../../Models/common';
import Table from '../custom/Table';
import SerialNumberSelectorModal from '../$PhysicalOrder/SerialNumberSelector';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDynamicForm } from '../forms/DynamicFormNew';
import Title from '../custom/Title';
import Divider from '../custom/Divider';
import AddressCard from '../custom/AddressCard';
import { TCompletePhysicalOrderParams } from '../../services/Transactions/types';
import { getCustomerActiveAddresses, sendOtpForEmployeeValidation } from '../../services/Customer';
import HighlightsCardAndCustomerDetails from '../custom/HighlightsCardAndCustomerDetails';
import BulkUploadOrderModal from '../Modals/BulkUploadMintedOrders';
import { getPvcCenterAddresses } from '../../services/PVC';
import { ICustomerAddress } from '../../Models/Customer';
import { TPvcCenterAddress } from '../../Models/PVC';
import EmployeeValidationModal from '../Modals/EmployeeValidationModal';
import { Description } from '@mui/icons-material';
import DownloadInvoice from './DownloadInvoice';
// import { generateIRN } from '../../services/Inventory';

export type TMintedSalesStpeKeys = 'PHYSICAL_ORDER' | 'BILLING' | 'SUMMARY'

const PAGE_INFO: IPageState = {
    title: 'Minted Sales',
    breadcrumbs: objToArray(MINTED_SALES).map(item => ({ path: item.key, label: item.value })),
    currentPage: MINTED_SALES.PHYSICAL_ORDER,
    path: PATHS.REDEEM_AT_PVC
}

type TMintedSalesSummaryKeys =
    'customerId'
    | 'customerName'
    | 'pvcName'
    | 'transactionDate'
    | 'purchasedGold'
    | 'purchasedSilver'
    | 'deliveryCharge'
    | 'totalTaxValue'
    | 'totalCharges'
    | 'roundingRs'
    | 'totalValue'

const SUMMARY_DETAILS: { id: TMintedSalesSummaryKeys, label: any, value: any }[] = [
    {
        id: 'customerId',
        label: "Customer Id",
        value: ""
    },
    {
        id: "customerName",
        label: "Customer Name",
        value: ""
    },
    {
        id: "pvcName",
        label: "PVC Name",
        value: ""
    },
    {
        id: "transactionDate",
        label: "Transaction Date",
        value: ""
    },
    {
        id: "purchasedGold",
        label: "Purchased Gold",
        value: ""
    },
    {
        id: "purchasedSilver",
        label: "Purchased Silver",
        value: ""
    },
    {
        id: 'deliveryCharge',
        label: 'Delivery Charges',
        value: ''
    },
    {
        id: 'totalTaxValue',
        label: "Total Tax Value Rs.",
        value: ''
    },
    {
        id: 'totalCharges',
        label: "Total Charges Rs.",
        value: ''
    },
    {
        id: 'roundingRs',
        label: "Rounding Rs.",
        value: ''
    },
    {
        id: 'totalValue',
        label: "Grand Total Rs.",
        value: ''
    },

]

const Container = styled.div`
    width: 100%;    
`

const EcomRedeemAtPVC = () => {

    const { pvcCenterDetails, setTransactionInfo, transactionInfo, resetOrder, setCapturedSteps, ecomphysicalOrder, cart, transactionDocuments, setTransactionDocuments } = useContext(EcomTransactionContext)
    const { globalTransactionNumber, status, updatedAt, } = transactionInfo
    const { user } = useContext(AuthContext)
    const { customerConfig } = useContext(CustomerContext)
    const [searchParams] = useSearchParams()
    const { id } = useParams()
    const { execute } = useService()
    const navigate = useNavigate()
    const step = searchParams.get('section')
    const [showBulkUploader, setShowBulkUploader] = useState(false)
    const { setecomphysicalOrder, setCart  } = useContext(EcomTransactionContext);
    const cartRef = useRef(cart);
    const { notify } = useContext(NotificationContext)
    const transactionRef = useRef(transactionInfo);
    const [isCompleted, setIsCompleted] = useState(false)

    useEffect(() => {
        cartRef.current = cart;
    }, [cart]);

    useEffect(() => {
        if (transactionRef?.current?.pvc_status == 'COMPLETED' || transactionInfo?.pvc_status == 'COMPLETED')
            setIsCompleted(true)

    }, [transactionInfo])

    const getTransitionDocumentsList = async () => {
        const {data, error} = await execute(()=> fetchTransactionDocumentsList({
            transactionId: transactionInfo.transactionId!,
            transactionType: TRANSACTION_TYPES.MINTED_SALES
        }))

        if(data) setTransactionDocuments(data.documentsList)
    }

    const hasFetched = useRef(false);
    useEffect(() => {
        if (!transactionInfo.transactionId || hasFetched.current) return;
        hasFetched.current = true;

        getTransitionDocumentsList()
    }, [transactionInfo.transactionId!])

    const getTransaction = async () => {
        const { data } = await execute(() => getEcomRedeemAtPvcOrderDetails({ orderID: id!, transactionType: "REDEEM_AT_PVC",pvcCenterId : user.centerId! }))
        if (data !== null) {
            setecomphysicalOrder(Array.isArray(data.order) ? data.order[0] : data.order);
        }
    }

    // const handleGenerateIRN = async () => {
    //     const redeemOrderId = String(transactionInfo?.redeemOrderId ?? '').trim();
    //     if (!redeemOrderId) {
    //         notify('Missing redeem order id', 'error');
    //         return;
    //     }

    //     const { data, error } = await execute(() => generateIRN({ redeemOrderId: redeemOrderId, type: 'ECOM_TAX_INVOICE' }))
        
    //     if(!error) {
    //         notify('IRN generated successfully')
    //     }
    // }
    
    // const getTransitionDocument = transactionDocuments.length 
    //     ? transactionDocuments.find(doc => doc.type === DOCUMENT_TYPES.ECOM_TAX_INVOICE) 
    //     : null

    const PageContent = useCallback(() => {
        return <>
            <MintedPhysicalOrder />
            <Billing path={PATHS.REDEEM_AT_PVC} nextSection='SUMMARY' prevSection='PHYSICAL_ORDER' nextButtonLable='Generate Invoice' />
            <Summary prevSection='SUMMARY' path={PATHS.REDEEM_AT_PVC} transitionHistory={[]} summaryDetails={getSummary()} />
            {!isCompleted ? (
                <Button
                    size="small"
                    onClick={verifyAndCompleteTransaction}
                    variant="contained"
                    startIcon={<Description />}
                >
                    Complete Order & Generate Invoice
                </Button>
            ) : (
                <DownloadInvoice
                    fileName={transactionInfo.globalTransactionNumber!}
                    label={'Download Invoice'}
                    documentType={'TAX_INVOICE'}
                />
            )}
            {/* {
                <>
                    <Button 
                        size="small" 
                        onClick={handleGenerateIRN} 
                        variant="outlined" 
                        startIcon={<Description />}
                        style={{ marginLeft: "20px" }}
                        disabled={
                            !getTransitionDocument ||
                            getTransitionDocument?.type === DOCUMENT_TYPES.ECOM_TAX_INVOICE &&
                            (getTransitionDocument?.raw_data.IRNNumber ?? "").trim() !== ""
                        }
                     >
                        {'Generate IRN'}
                    </Button>
                </>
            } */}
        </>
    }, [ecomphysicalOrder])
    async function verifyAndCompleteTransaction() {
        const allValid = cartRef.current.every(item => {
            const qty = Number(item.quantity) || 0;

            // normalize serialNumbers → always an array
            const serials = typeof item.serialNumbers === "string"
                ? item.serialNumbers.split(",").map(s => s.trim()).filter(Boolean)
                : Array.isArray(item.serialNumbers)
                    ? item.serialNumbers
                    : [];

            // must have quantity
            if (qty <= 0) return false;

            // if serial numbers are required, length must match quantity
            if (item.isSerialNo) {
                return serials.length === qty;
            }

            return true;
        });

        const redeemOrderId = String(transactionInfo?.redeemOrderId ?? '').trim();
        const cartItems = Array.isArray(cartRef.current) ? cartRef.current : [];

        // 1) validations
        if (!allValid) {
            notify('Please select serial numbers', 'error');
            return;
        }
        if (!redeemOrderId) {
            notify('Missing redeem order id', 'error');
            return;
        }
        if (cartItems.length === 0) {
            notify('Cart is empty', 'error');
            return;
        }

        // 2) call
        try {
            const res = await execute(() =>
                completeEcomRedeemAtPvcOrder({ redeemOrderId, lineItems: cartItems })
            );

            const { data, error } = res ?? {};
            if (error) {
                notify(error.reason, 'error');
                return;
            }

            notify('Order completed', 'success');

            if (data) {
                getTransaction()
                setTimeout(() => {
                    navigate(0);
                }, 2000); // refresh current route in v6+
            }

        } catch (e) {
            notify('Something went wrong', 'error');
        }
    }
    const getSummary = () => {
        let totalTaxValue = 0
        Array.isArray(ecomphysicalOrder.taxes) ? ecomphysicalOrder.taxes.forEach((tax) => {
            totalTaxValue += tax.taxAmount
        }) : Object.values(ecomphysicalOrder.taxes || {}).forEach((tax: any) => {
            totalTaxValue += tax.taxAmount
        })
        let totalCharges = 0
        ecomphysicalOrder.charges?.forEach((charge) => {
            totalCharges += charge.preTaxAmount
            totalTaxValue += charge.postTaxAmount - charge.preTaxAmount
        })
        const roundingRs = getTwoPointNumber((Math.round(ecomphysicalOrder.totalPrice || 0) - (ecomphysicalOrder.totalPrice || 0)) || 0)
        return SUMMARY_DETAILS.map(field => {
            switch (field.id) {
                case 'customerId':
                    field.value = customerConfig.customerRefNo
                    break;
                case 'customerName':
                    field.value = customerConfig.fullName
                    break;
                case 'pvcName':
                    field.value = pvcCenterDetails.name
                    break;
                case 'purchasedGold':
                    field.value = ecomphysicalOrder.totalGoldWeight ? ecomphysicalOrder.totalGoldWeight : 0 + ' gm'
                    break;
                case 'purchasedSilver':
                    field.value = ecomphysicalOrder.totalSilverWeight ? ecomphysicalOrder.totalSilverWeight : 0 + ' gm'
                    break;
                case 'transactionDate':
                    field.value = updatedAt ? formatDate(updatedAt) : ''
                    break;
                case 'deliveryCharge':
                    const deliveryCharge = ecomphysicalOrder.charges?.filter((charge) => {
                        return charge.chargeId === CHARGE_TYPES.DELIVERY_CHARGE
                    })[0]
                    field.value = deliveryCharge ? getFormattedCurrency(deliveryCharge.postTaxAmount) : null
                    break;
                case 'totalTaxValue':
                    field.value = getFormattedCurrency((totalTaxValue)) || 0
                    break;
                case 'totalCharges':
                    field.value = getFormattedCurrency((totalCharges))
                    break;
                case 'roundingRs':
                    field.value = getFormattedCurrency((roundingRs))
                    break;
                case 'totalValue':
                    field.value = getFormattedCurrency((ecomphysicalOrder.totalPrice || 0))
                    break;
            }
            return field
        })
    }

    const cancelTransactionHandler = (transactionId: string) => {
        navigate(PATHS.PVC_TRANSACTIONS)
    }

    useEffect(() => {
        resetOrder()
        if (id) {
            getTransaction()
        }
        else {
            setTransactionInfo({
                currency: CURRENCIES.INR,
                pvcCenterId: user.centerId!,
                status: TRANSACTION_STATUS.PHYSICAL_ORDER_INITIATED,
                transactionType: TRANSACTION_TYPES.MINTED_SALES,
                weightUOM: WEIGHT_UNITS.GM,
            } as TTransactionBasic)
        }
        return () => resetOrder()
    }, [user])

    useEffect(() => {
        if (ecomphysicalOrder?.id) {
            getSummary()
        }

    }, [ecomphysicalOrder])

    return (
        <Container>
            {id ? <HighlightsCardAndCustomerDetails
                customerConfig={customerConfig}
                globalTransactionNumber={globalTransactionNumber as string}
                status={status}
                transactionType={transactionInfo.transactionType}
                onSuccessCancelTransaction={cancelTransactionHandler}
            />
                : <>
                    <Button variant='outlined' onClick={() => setShowBulkUploader(true)}>Bulk Upload</Button>
                </>
            }
            <PageContent />
            <BulkUploadOrderModal
                open={Boolean(showBulkUploader)}
                onClose={() => setShowBulkUploader(false)}
            />
        </Container>
    )
}


const MintedPhysicalOrder = () => {
    const [searchString, setSearchString] = useState('')
    const { products, cart, setCart, transactionInfo, lineItems, capturedSteps, ecomphysicalOrder, setCapturedSteps, billingData } = useContext(EcomTransactionContext)
    const { notify } = useContext(NotificationContext)
    const { execute } = useService()
    const { customerConfig } = useContext(CustomerContext)
    const { id } = useParams()
    const navigate = useNavigate()
    const [showSerialNumberModal, setShowSerialNumberModal] = useState<boolean | string>(false);
    const [availableSerialNumbers, setAvailableSerialNumbers] = useState<{ [key: string]: number[] }>({})
    const [selectedSerialNumbers, setSelectedSerialNumbers] = useState<{ [key: string]: number[] }>({})
    const [quantity, setQuantity] = useState<{ [key: string]: string }>({})
    const [forceNavigate, setForceNavigate] = useState(false)
    const [filteredProducts, setFilteredProducts] = useState(products.filter((item) => {
        if (item.inventory.inventory_type === 1 || item.inventory.inventory_type === 7)
            return item
    }))
    const [showProducts, setShowProducts] = useState(products.filter((item) => {
        if (item.inventory.inventory_type === 1 || item.inventory.inventory_type === 7)
            return item
    }))
    const [selectedProducts, setSelectedProducts] = useState<TMintedSelectedProduct[]>([])
    const [openEmployeeValidationModal, setOpenEmployeeValidationModal] = useState(false);
    const [otpSentTo, setOtpSentTo] = useState('');
    const [formData, setFormData] = useState<any>();

    useEffect(() => {
        if (products?.length === 0)
            getAllProducts()


        if (selectedProducts?.length > 0) {
            const filtered = products.filter(prod => selectedProducts.some(selProd => selProd.skuId === prod.skuId));
        }
    }, [products])

    useEffect(() => {
        setCart(cart)
    }, [cart])


    useEffect(() => {
        let data: any = products?.filter((item) => {
            if (item.inventory.inventory_type === 1 || item.inventory.inventory_type === 7)
                return item
        })
        if (data.length > 0) {
            setFilteredProducts(data)
            setShowProducts(data)
        }
    }, [products])

    useEffect(() => {
        let selectProduct: any = [];
        let cartItem: any = [];

        if (lineItems.length > 0) {
            lineItems.forEach((item: any) => {
                let data = {
                    weight: item.weight!,
                    skuId: item.productId!,
                    name: item.product.product_name!,
                    product_name: item.product.product_name!,
                    inventory: {
                        quantity: item.quantity!, // available qty
                        serial_numbers: item.product.is_serial_no ? '[]' : '',
                    },
                    description: item.product.description!,
                    metalType: item.metalType!,
                    currencyPair: item.metalType!,
                    purity: item.product.metal_purity!,
                    metal_purity: item.product.metal_purity!,
                    isSerialNo: item.product.is_serial_no!,
                    orderQty: item.quantity!, // available qty
                };
                let quantityObj: { [key: string]: string } = {};
                quantityObj[item.productId!] = item.quantity!.toString();
                setQuantity((prev) => ({ ...prev, ...quantityObj }));
                let cartData = {
                    productId: item.productId,
                    discount: item.discount,
                    isDigital: item.isDigital,
                    metalType: item.metalType!,
                    quantity: item.quantity,
                    serialNumbers: (() => {
                        try {
                            return item.product?.is_serial_no ? JSON.parse(item?.serialNumbers) : 'M';
                        } catch (e) {
                            return [];
                        }
                    })(),
                    totalTax: item.totalTax,
                    totalValue: item.totalValue,
                    unitPrice: item.unitPrice,
                    unitPriceTaxInclusive: item.unitPriceTaxInclusive,
                    weight: item.weight,
                    fineWeight: item?.product?.fine_weight,
                    isSerialNo: item.product.is_serial_no,
                    productName: item.product.product_name,
                };

                selectProduct.push(data);
                cartItem.push(cartData);
            });

            setSelectedProducts(selectProduct);
            setCart(cartItem);
        }
    }, [lineItems]);

    useEffect(() => {
        searchProducts()
    }, [searchString])

    useEffect(() => {
        if (forceNavigate) goToNextSection()
    }, [forceNavigate])
    function getSerialNumbersForSelectedProducts(skuId: string) {
        let serialNumbers;
        products.forEach((product) => {
            if (product.skuId === skuId) {
                try {
                    serialNumbers = JSON.parse(product.inventory.serial_numbers);
                } catch (e) {
                    serialNumbers = [];
                }
            }
        })
        return serialNumbers;
    }

    useEffect(() => {// for serial number in the selected product
        if(!selectedProducts) return;
        selectedProducts?.map((product) => {
            let parsedSerialNumbers: any = []
            if (product.isSerialNo) {
                parsedSerialNumbers = (() => {
                    try {
                        let serialNumAvailable = getSerialNumbersForSelectedProducts(product.skuId)
                        // return JSON.parse(product.inventory.serial_numbers);
                        return serialNumAvailable;
                    } catch (e) {
                        return [];
                    }
                })()
                setAvailableSerialNumbers((prev) => ({ ...prev, [product.skuId]: parsedSerialNumbers }))
            }
            lineItems.length > 0 && lineItems.map((lineItem) => {
                if (lineItem?.product?.is_serial_no && product.skuId === lineItem.productId) {
                    const prevSerialNo = (() => {
                        try {
                            return JSON.parse(lineItem.serialNumbers);
                        } catch (e) {
                            return [];
                        }
                    })()
                    prevSerialNo?.forEach((el: any) => {
                        if (!parsedSerialNumbers.includes(el))
                            parsedSerialNumbers.push(el)
                    });
                    parsedSerialNumbers?.sort((a: any, b: any) => a - b)
                    setAvailableSerialNumbers((prev) => ({ ...prev, [product.skuId]: parsedSerialNumbers }))
                }
            })
        })
    }, [selectedProducts])

    const getAllProducts = async () => {
        await execute(() => getecomRedeemAtPvcProducts({redeemAtPvc : true}))
    }


    const searchProducts = () => {
        if (searchString.length === 0) return setShowProducts(filteredProducts)
        if (searchString.length > 1) {
            let filteredData = filteredProducts.filter((product: any) => {
                if (
                    (product.inventory?.serial_numbers &&
                        product.inventory.serial_numbers
                            .toString()
                            .toLowerCase()
                            .includes(searchString.toLowerCase())) ||
                    product.name
                        .toLowerCase()
                        .includes(searchString.toLowerCase()) ||
                    product.purity
                        .toString()
                        .includes(searchString.toLowerCase()) ||
                    product.description
                        .toLowerCase()
                        .includes(searchString.toLowerCase()) ||
                    getMetalType(product)
                        .toLowerCase()
                        .includes(searchString.toLowerCase()) ||
                    product.skuId
                        .toLowerCase()
                        .includes(searchString.toLowerCase())
                ) {
                    return product;
                }
            });
            setShowProducts(filteredData)
        }
    }

    const getTwoPointNumber = (number: number) => {
        return Number(number.toFixed(2))
    }

    const openSerialModal = (id: string) => {
        setShowSerialNumberModal(id);
    }

    const removeFromCart = (id: string) => {
        setQuantity(prev => ({ ...prev, [id]: '0' }))
        setSelectedSerialNumbers(prev => ({ ...prev, [id]: [] }));
        setCart(prev => ([...prev.filter(cartItem => id != cartItem.productId)]))
        setSelectedProducts(prev => ([...prev.filter(item => id != item.skuId)]))

    }

    const quantityHandler = (id: string, quantity: number, product: TProductsColumns) => {
        if (!quantity) {
            removeFromCart(id)
        }
        else {
            const totalTax = getAmount(product.taxAmount, quantity, customerConfig)
            const totalValue = getTotalValue(product, quantity, customerConfig)
            setCart(prev => ([
                ...prev.map(cartItem => {
                    return id === cartItem.productId ? {
                        ...cartItem,
                        quantity,
                        totalTax,
                        totalValue
                    } : cartItem
                })
            ]
            ))
        }
    }

    const changeQuantity = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
        const value = e.target.value
        const product = selectedProducts.filter(product => id === product.skuId)[0]
        if (!product.taxAmount) {
            let productData = filteredProducts.filter(product => id === product.skuId)[0]
            product.taxAmount = productData.taxAmount
        }
        if (!value.length) return setQuantity(prev => ({ ...prev, [id]: '0' }))
        else if (NUMBER_REGEX.test(value)) {
            let newValue = value.replace(/^0+/, "");
            setSelectedSerialNumbers(prev => ({ ...prev, [id]: [] }))
            setQuantity(prev => ({ ...prev, [id]: newValue }))
        }
        if (product.taxAmount)
            quantityHandler(id, Number(value), product)
    }

    const AddedProductColumns: TColumn<TProductsColumns>[] = [
        {
            field: 'skuId',
            headerName: 'Item Number',
            minWidth: 180,
            flex: 1
        },
        {
            field: 'name',
            headerName: 'Product Name',
            minWidth: 250,
            flex: 1
        },
        {
            field: 'currencyPair',
            headerName: 'Metal Type',
            flex: 1
        },
        {
            field: 'purity',
            headerName: 'Purity',
            flex: 1
        },
        {
            field: 'weight',
            headerName: 'Unit Weight',
            flex: 1
        },
        {
            field: 'totalWeight',
            headerName: 'Net Weight',
            renderCell(params) {
                const itemInCart = cart.filter(product => params.id === product.productId)[0]
                return itemInCart ? getTwoPointNumber(params.row.weight * itemInCart.quantity) : 0
            },
            flex: 1
        },
        {
            field: 'amount',
            headerName: 'Amount (Incl. Taxes)',
            minWidth: 130,
            renderCell(params) {
                const itemInCart = cart.filter(product => params.id === product.productId)[0]
                return itemInCart ? getTwoPointNumber(itemInCart.totalValue) : 0
            },
            flex: 1
        },
        {
            field: 'orderQty',
            headerName: 'Ordered Qty',
            minWidth: 100,
            flex: 1
        },
        {
            field: 'serialNumbers',
            headerName: 'Serial Numbers',
            minWidth: 60,
            renderCell(params) {
                return params.row.isSerialNo ?
                    <>
                        {quantity[params.row.skuId] !== '0' && <IconButton onClick={() => openSerialModal(params.row.skuId)}>
                            <VisibilityIcon />
                        </IconButton>}
                    </>
                    : <></>
            },
            flex: 1
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            minWidth: 150,
            renderCell(params) {
                return <TextField
                    disabled={Boolean(params.row.orderQty) ? Boolean(params.row.orderQty) : !cart?.filter(product => params.id === product.productId)[0]}
                    value={params.row.orderQty ?? quantity[params.id]}
                    onChange={e => changeQuantity(e, params.id as string)}
                    size='small'
                    onKeyDown={e => e.stopPropagation()}
                />
            },
            flex: 1
        },
        {
            field: 'actions',
            headerName: '',
            renderCell(params) {
                return <></>
            },
            flex: 1
        },
    ]

    useEffect(() => {
    }, [selectedSerialNumbers])

    const goToNextSection = () => {
        let path = PATHS.REDEEM_AT_PVC, nextSection = 'BILLING'
        if (!capturedSteps.includes('PHYSICAL_ORDER'))
            return notify('Complete Physical Order first.', 'error')

        if (id) navigate(path + '/' + id + '?section=' + nextSection)
        else navigate(path + '?section=' + nextSection)
    }
    const submitHandler = async (formData: any) => {
        let totalGoldWeight = 0;
        let totalSilverWeight = 0;
        for (let i = 0; i < cart.length; i++) {
            if (cart[i].metalType == "gold")
                totalGoldWeight += cart[i].weight

            if (cart[i].metalType == "silver")
                totalSilverWeight += cart[i].weight

        }

        if (lineItems?.length === 0 && (customerConfig.userType === "F&F" || customerConfig.userType === "employee")) {
            const { data, error } = await execute(() => sendOtpForEmployeeValidation({ dgCustomerRefNo: customerConfig.dgCustomerRefNo! }));
            if (error === null && data?.status === 'ok') {
                setOtpSentTo(data.otpSentTo);
                setFormData(formData);
                setOpenEmployeeValidationModal(true);
            }
        } else {
            finalSubmit(formData);
        }
    }

    const finalSubmit = async (formData: any) => {
        for (let lineItem of cart) {
            if (lineItem.isSerialNo && selectedSerialNumbers[lineItem.productId]) {
                const serialNumbersOfSku = selectedSerialNumbers[lineItem.productId]

                if (lineItem.isSerialNo && serialNumbersOfSku.length > lineItem.quantity) {
                    return notify(`Serial Numbers can't be more than quantity for item ${lineItem.productName}`, 'error')
                } else if (lineItem.isSerialNo && serialNumbersOfSku.length < lineItem.quantity) {
                    return notify(`Serial Numbers can't be less than quantity for item ${lineItem.productName}`, 'error')
                }
            }
        }

        const cartItemsWithoutSerialNumbers = []
        if (!cart.length) {
            return notify('Add Products into cart', 'error')
        }
        for (let cartItem of cart) {
            if (!cartItem.serialNumbers && cartItem.isSerialNo) cartItemsWithoutSerialNumbers.push(cartItem)
        }

        if (cartItemsWithoutSerialNumbers.length > 0) return notify(`Enter serial numbers for item ${cartItemsWithoutSerialNumbers[0].productId}`, 'error')

        if (lineItems?.length === 0) {
            const { error } = await execute(() => createAndCompleteMintedPhysicalOrder({
                lineItems: cart,
                ...ecomphysicalOrder,
                ...formData,
                transactionType: transactionInfo.transactionType,
                globalTransactionNumber: transactionInfo.globalTransactionNumber!
            }))

            if (error === null) {
                notify('Order placed successfully')
                setCapturedSteps(prev => ([...prev, 'PHYSICAL_ORDER']))
                setForceNavigate(true)
            }

        } else {
            const { error } = await execute(() => updateMintedPhysicalOrder({
                lineItems: cart,
                ...formData,
                transactionType: transactionInfo.transactionType,
                globalTransactionNumber: transactionInfo.globalTransactionNumber!
            }))

            if (error === null) {
                notify('Order updated successfully')
                setCapturedSteps(prev => ([...prev, 'PHYSICAL_ORDER']))
                setForceNavigate(true)
            }
        }
    }

    const onVerifyOtpClose = (success?: boolean) => {
        setOpenEmployeeValidationModal(false);
        if (success) {
            finalSubmit(formData);
        }
    }

    return (
        <>
            {transactionInfo?.pvc_status !== TRANSACTION_STATUS.COMPLETED && //PHYSICAL_ORDER
                <div style={{ padding: '20px 0', display: 'flex', flexDirection: 'column' }}>

                    <div style={{ display: 'flex', gap: '10px', flexDirection: 'column', paddingTop: '10px' }}>
                        <SerialNumberSelectorModal
                            availableSerialNumbers={availableSerialNumbers[showSerialNumberModal as string]}
                            onClose={(updatedSerialNumbers) => {
                                setSelectedSerialNumbers(prev => ({ ...prev, [showSerialNumberModal as string]: updatedSerialNumbers }))
                                setCart(prev => {
                                    return [...prev.map(item => {
                                        if (item.productId === showSerialNumberModal) {
                                            return { ...item, serialNumbers: updatedSerialNumbers.join(',') }
                                        } else return item
                                    })]
                                })
                                setShowSerialNumberModal(false)
                            }}
                            quantity={+quantity[showSerialNumberModal as string]}
                            selectedSerialNumbers={selectedSerialNumbers[showSerialNumberModal as string]}
                            show={Boolean(showSerialNumberModal)}
                        />
                        <Title>Select Serial Numbers</Title>
                        <Table
                            columns={AddedProductColumns}
                            rows={(selectedProducts ?? []).filter((row: TProductsColumns) => row?.isSerialNo)}
                            getRowId={(row: TProductsColumns) => row.skuId}
                        />
                    </div>
                </div>
            }
            <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
                <MintedPhysicalOrderDetails submitHandler={submitHandler} />
            </div>
            <EmployeeValidationModal
                open={openEmployeeValidationModal}
                onClose={onVerifyOtpClose}
                dgCustomerRefNo={customerConfig.dgCustomerRefNo!}
                phone={otpSentTo}
            />
        </>
    )
}

const getAddressesOptions = (addresses: ICustomerAddress[] | TPvcCenterAddress[]) => {
    return addresses?.map(address => ({ label: address?.name + ' - ' + address?.line1 + ' - ' + address?.city, value: address.id }))
}

const MintedPhysicalOrderDetails = ({ submitHandler }: { submitHandler: any }) => {
    const { setFormData, formData, setField } = useDynamicForm({ formConfig: ORDER_DETAILS_FORM })
    const { customerConfig, setCustomerAddresses, customerAddresses } = useContext(CustomerContext)
    const { transactionInfo } = useContext(EcomTransactionContext);
    const { user: { centerId }, pvcAddresses } = useContext(AuthContext)
    let customerGstAddressesArray: any = []
    const [customerGstAddresses, setCustomerGstAddresses] = useState<ICustomerAddress[]>([]);
    const [shippingAddressId, setShippingAddressId] = useState<any>();
    const { lineItems, ecomphysicalOrder, capturedSteps, transactionInfo: { status } } = useContext(EcomTransactionContext)
    const { execute } = useService()

    useEffect(() => {
        if (!transactionInfo?.globalTransactionNumber) {
            setCustomerAddresses([])
            setField('shippingAddressId', { options: [] })
            setField('billingAddressId', { options: [] })
        }
    }, [transactionInfo])


    const updateForm = () => {
        setField('customerId', { options: [{ label: customerConfig.displayName, value: customerConfig.customerRefNo }] })
    }

    useEffect(() => {
        updateForm()
        if (customerConfig.customerRefNo)
            execute(() => getCustomerActiveAddresses({ customerRefNo: customerConfig.customerRefNo! }))
        if (centerId && customerConfig.isCorporate != 'Y') execute(() => getPvcCenterAddresses({ pvcCenterId: centerId }))

    }, [centerId, customerConfig])

    useEffect(() => {
        if (customerConfig?.gstin) {
            const gstStateCode = customerConfig?.gstin.slice(0, 2);
            for (let addresses of customerAddresses) {
                if (addresses.stateCode == gstStateCode) {
                    customerGstAddressesArray.push(addresses)
                }
            }
            setCustomerGstAddresses(customerGstAddressesArray)
        }
        setField('billingAddressId', { options: getAddressesOptions(customerAddresses) })
        setField('shippingAddressId', { options: getAddressesOptions( pvcAddresses) })

        setFormData({ ...formData, isShippingAsbillingAddressId: false })
        if (customerConfig?.gstin || customerConfig.isCorporate === "N") setFormData({ ...formData, isShippingAsbillingAddressId: true })

    }, [pvcAddresses])

    useEffect(() => {
        if (formData?.billingAddressId) setField('isShippingAsbillingAddressId', { isVisible: true })
    }, [formData?.billingAddressId])

    useEffect(() => {

        const isShippingAsbillingAddressId = formData.shippingAddressId === formData.billingAddressId

        setFormData({
            ...formData,
            isShippingAsbillingAddressId
        })
    }, [formData?.shippingAddressId, formData.billingAddressId])

    useEffect(() => {
        if (formData.isDoorstepDelivery || customerConfig.isCorporate === 'Y' || customerConfig?.gstin) {
            if (customerConfig.isCorporate != 'Y') {
                if (pvcAddresses.map(address => address.id).includes(formData.shippingAddressId!)) {
                    setFormData({ ...formData, shippingAddressId: '' })
                }
            }
            if (!customerConfig?.gstin && !customerAddresses.map(address => address.id).includes(formData.shippingAddressId!) && customerConfig.isCorporate != 'Y') {
                setShippingAddressId(null)
                setFormData({ ...formData, shippingAddressId: '' })
            }
            setField('shippingAddressId', { isVisible: true, options: customerConfig?.gstin ? getAddressesOptions(customerGstAddresses) : getAddressesOptions(customerAddresses) })
            if (formData.billingAddressId) setField('isShippingAsbillingAddressId', { isVisible: true })
        } else {
            setField('shippingAddressId', { isVisible: true, options: getAddressesOptions(pvcAddresses) })
            setField('billingAddressId', { isVisible: true, options: getAddressesOptions(customerAddresses) })
            setField('isShippingAsbillingAddressId', { isVisible: false })
            setFormData({ ...formData, isShippingAsbillingAddressId: false })
            if (customerAddresses.map(address => address.id).includes(formData.shippingAddressId!) && !formData.isDoorstepDelivery) {
                setFormData({ ...formData, shippingAddressId: '' })
            }
        }

    }, [ecomphysicalOrder, formData.isDoorstepDelivery, submitHandler])


    useEffect(() => {
        if (formData.isShippingAsbillingAddressId) setFormData({ ...formData, shippingAddressId: formData.billingAddressId })

    }, [formData.isShippingAsbillingAddressId])

    useEffect(() => {
        if (formData && formData?.shippingAddressId) {
            setShippingAddressId(formData.shippingAddressId)
        }
    }, [formData?.shippingAddressId])

    useEffect(() => {
        if (ecomphysicalOrder.isDoorstepDelivery || customerConfig.isCorporate === 'Y' || (customerConfig?.gstin && customerConfig?.isCorporate === "N")) {
            setField('shippingAddressId', {
                isVisible: true,
                options: getAddressesOptions(customerGstAddresses)
            })

            setField('billingAddressId', {
                isVisible: true,
                options: getAddressesOptions(customerGstAddresses)
            })
        } else {
            setField('shippingAddressId', {
                isVisible: true,
                options: getAddressesOptions(pvcAddresses)
            })

            setField('billingAddressId', {
                isVisible: true,
                options: getAddressesOptions(customerAddresses)
            })
        }
        setFormData({
            id: ecomphysicalOrder.id,
            status: ecomphysicalOrder.status,
            billingAddressId: ecomphysicalOrder?.billingAddressId,
            shippingAddressId: pvcAddresses[0]?.id,
        } as TCompletePhysicalOrderParams)
    }, [ecomphysicalOrder])
    useEffect(() => {
        if (customerConfig?.gstin) {
            const gstStateCode = customerConfig?.gstin.slice(0, 2);
            for (let addresses of customerAddresses) {
                if (Number(addresses.stateCode) === Number(gstStateCode) && customerGstAddresses?.length < 1) {
                    customerGstAddressesArray.push(addresses)
                }
            }
            setCustomerGstAddresses(customerGstAddressesArray)
        }
        if (customerConfig?.isCorporate === "N" && customerConfig?.gstin) {
            setField('billingAddressId', { options: customerConfig?.gstin ? getAddressesOptions(customerGstAddresses) : getAddressesOptions(customerAddresses) })
            setField('shippingAddressId', { options: customerConfig?.gstin ? getAddressesOptions(pvcAddresses) : getAddressesOptions(pvcAddresses) })
            if (customerAddresses.length > 0) {
                for (let address of customerGstAddresses) {
                    if (address?.id === formData.billingAddressId) {
                        setField('shippingAddressId', { options: [{ label: address?.name + ' - ' + address?.line1 + ' - ' + address?.city, value: address.id }] })
                    }
                }
            }
        } else {
            setField('shippingAddressId', { options: ecomphysicalOrder?.isDoorstepDelivery ? getAddressesOptions(pvcAddresses) : getAddressesOptions(pvcAddresses) })
            setField('billingAddressId', { options: getAddressesOptions(customerAddresses) })
        }


    }, [customerAddresses])



    return <>
        <div style={{ padding: '10px 0' }}>
            <Title>Physical Order Details</Title>
            <Divider style={{ marginBottom: '10px' }} />
        </div>
        <div style={{ display: 'flex', gap: '20px' }}>
            <div style={{ width: 'calc(50% - 10px)' }}>
                {formData.billingAddressId && customerAddresses.length > 0 ? <AddressCard address={customerAddresses.filter(address => address.id === formData.billingAddressId)[0]} heading='Billing Address' /> : <></>}
            </div>
            <div style={{ width: 'calc(50% - 10px)' }}>
                {formData.isDoorstepDelivery || customerConfig.isCorporate === 'Y' || customerConfig?.gstin ?
                    (shippingAddressId && customerAddresses.length > 0 ? <AddressCard address={pvcAddresses[0]} heading='Shipping Address' /> : <></>)
                    :
                    (formData.shippingAddressId && pvcAddresses.length > 0 && (pvcAddresses?.some(address => address.id === formData.shippingAddressId))
                        ? <AddressCard address={pvcAddresses.filter(address => address.id === formData.shippingAddressId)[0]} heading='Shipping Address' />
                        : (pvcAddresses.length > 0
                            ? <AddressCard address={pvcAddresses[0]} heading='Shipping Address' />
                            : <></>)
                    )
                }
            </div>
        </div>
        {status !== TRANSACTION_STATUS.PHYSICAL_ORDER_INITIATED &&
            <div style={{ padding: '20px 0' }}>
                <Title>Cart Items</Title>
                <Divider style={{ marginBottom: '10px' }} />
                <Table columns={LINE_ITEM_COLUMNS} rows={lineItems} />
            </div>
        }
    </>
}

export default EcomRedeemAtPVC